// extracted by mini-css-extract-plugin
export default {"root":"laguage_settings-module___root___a05478e3","form":"laguage_settings-module___form___e92ab96a","button":"laguage_settings-module___button___f6b63082"};